import { Injectable, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: any[] = [];

  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  remove(toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  showError(message?: string, options?: any) {
    options = options || {};
    options.classname = options.classname || 'bg-error';
    options.header = options.header || 'Oops!';

    let unexpectedErrorMessage = $localize`:@@cj2_generic__unexpectedErrorMessage:An unexpected error occurred.`;

    message = message || unexpectedErrorMessage;

    this.show(message, options);
  }

  showSuccess(message?: string, options?: any) {
    options = options || {};
    options.classname = options.classname || 'bg-success';
    options.header = options.header || 'Success!';

    message = message || '';

    this.show(message, options);
  }
}
